var notificationsList = (function () {
  const init = function () {
    $("#notifications-datatable").DataTable({
      autoWidth: false,
      responsive: true,
      columnDefs: [
        { className: "valid-from-column", targets: 0 },
        { className: "title-column", targets: 1 },
        { className: "is-draft-column", targets: 2 },
        { className: "type-column", targets: 3 },
        { className: "for-users-count-column", targets: 4 },
        { className: "users-viewed-column", targets: 5 },
        { className: "actions-column desktop", targets: 6 },
        { orderable: false, targets: 6 },
      ],
      language: {
        url: "https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json",
        //TODO: make it depends on current culture not on sdn call
      },
    });

    $("#notifications-datatable").on("click", ".mdi-delete", function () {
      const id = $(this).data("notification-id");
      const title = $(this).data("notification-title");
      $("#delete-notification-title").text(title);
      $("#delete-button").attr("data-notification-id", id);
    });

    $("#delete-button").on("click", function () {
      const notificationIdToDelete = $(this).data("notification-id");
      $("#delete-modal").modal("hide");
      sendDeleteRequest(notificationIdToDelete);
    });

    $("#notifications-datatable").on("click", ".mdi-send", function () {
      const id = $(this).data("notification-id");
      const title = $(this).data("notification-title");
      $("#publish-notification-title").text(title);
      $("#publish-button").attr("data-notification-id", id);
    });

    $("#publish-button").on("click", function () {
      const notificationIdToPublish = $(this).data("notification-id");
      $("#publish-modal").modal("hide");
      sendPublishRequest(notificationIdToPublish);
    });

    function sendDeleteRequest(id) {
      $.ajax({
        url: `/Notifications/Delete/${id}`,
        method: "DELETE",
        contentType: "application/json",
      }).done(function (data) {
        $.showNotification(data.header, data.message, data.success);
      });
    }

    function sendPublishRequest(id) {
      $.ajax({
        url: `/Notifications/Publish/${id}`,
        method: "POST",
        contentType: "application/json",
      }).done(function (data) {
        $.showNotification(data.header, data.message, data.success);
      });
    }
  };

  return {
    init: init,
  };
})();
